import { FC, useRef, useState } from 'react';

import { containerStyle } from './styles.ts';

import LikesList from '@/components/Likes/LikesList.tsx';
import TabBar from '@/components/Likes/Tabbar/TabBar.tsx';
import SentLikesList from '@/components/Likes/SentLikesList.tsx';
import Guard from '@/components/Guard/Guard.tsx';

const Likes: FC = () => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const handleTabChange = (index: number) => {
    setActiveTabIndex(index);

    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({ top: 0, behavior: 'auto' });
    }
  };

  return (
    <Guard component="likes">
      <div ref={scrollContainerRef} style={containerStyle}>
        {activeTabIndex === 0 && <LikesList />}
        {activeTabIndex === 1 && <SentLikesList />}
      </div>
      <TabBar
        activeTabIndex={activeTabIndex}
        handleTabChange={handleTabChange}
      />
    </Guard>
  );
};

export default Likes;
